export enum EPaymentBeneficiaryFilter {
    ALL = "all",
    COMPLETED = "completed",
}
